import { render, staticRenderFns } from "./Tracts.vue?vue&type=template&id=2478c7f4&"
import script from "./Tracts.vue?vue&type=script&lang=js&"
export * from "./Tracts.vue?vue&type=script&lang=js&"
import style0 from "./Tracts.vue?vue&type=style&index=0&id=2478c7f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports